var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeBrowser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DD1547CB-06D3-448B-B81F-93C9C0E6B1C6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.54668888%",
    y1: "55.3564522%",
    x2: "36.948096%",
    y2: "42.7409604%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0,
    offset: "66%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-4",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-6",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.0252036%",
    y1: "87.7726931%",
    x2: "41.908848%",
    y2: "66.3546891%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0,
    offset: "33%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-11",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "0 70.7249115 37.0289115 70.7249115 54.2150649 53.538758 54.2150649 40.6668241 23.586758 40.6668241 0 0.212174734"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.977965%",
    y1: "-4.840625%",
    x2: "49.2468033%",
    y2: "45.4140625%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0,
    offset: "66%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-16",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-18",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-20",
    points: "2.21015348 0 17.5265171 26.5218418 0.340363636 56.5799292 41.1088548 56.5799292 41.1088548 0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-22",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-4.87755102%",
    cy: "-0.248210024%",
    fx: "-4.87755102%",
    fy: "-0.248210024%",
    r: "401.326969%",
    gradientTransform: "translate(-0.048776,-0.002482),scale(0.267219,1.000000),translate(0.048776,0.002482)",
    id: "radialGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-25",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-27",
    points: "0.428769776 0 0.428769776 17.8315183 17.8403589 47.7393152 33.1523022 21.2174734 72.0510035 21.2174734 72.0510035 0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-29",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-0.165938865%",
    cy: "0.103626943%",
    fx: "-0.165938865%",
    fy: "0.103626943%",
    r: "136.321397%",
    gradientTransform: "translate(-0.001659,0.001036),scale(1.000000,0.847520),translate(0.001659,-0.001036)",
    id: "radialGradient-31"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-32",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "10.3400309%",
    cy: "-12.2148338%",
    fx: "10.3400309%",
    fy: "-12.2148338%",
    r: "226.352396%",
    gradientTransform: "translate(0.103400,-0.122148),scale(1.000000,0.496419),translate(-0.103400,0.122148)",
    id: "radialGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-35",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-37",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-39",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "14.9352273%",
    cy: "13.6443182%",
    fx: "14.9352273%",
    fy: "13.6443182%",
    r: "100.423864%",
    id: "radialGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1.0-Mojo-SignIn-supported_browser",
    transform: "translate(-760.000000, -535.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-side",
    transform: "translate(760.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome-browser-icon",
    transform: "translate(0.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.746399, 0.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB4437",
    points: "0.428769776 0 0.428769776 47.7393152 17.8403589 47.7393152 33.1523022 21.2174734 72.0510035 21.2174734 72.0510035 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-3)",
    points: "0.428769776 0 0.428769776 47.7393152 17.8403589 47.7393152 33.1523022 21.2174734 72.0510035 21.2174734 72.0510035 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillOpacity: 0.15,
    fill: "#3E2723",
    fillRule: "nonzero",
    mask: "url(#mask-5)",
    points: "24.0066871 47.5846045 6.40060449 17.3894876 6.14422668 17.8315183 23.6221204 47.8011995"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-7)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.072491)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0F9D58",
    points: "0 70.7249115 37.0289115 70.7249115 54.2150649 53.538758 54.2150649 40.6668241 23.586758 40.6668241 0 0.212174734"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-8)",
    points: "0 70.7249115 37.0289115 70.7249115 54.2150649 53.538758 54.2150649 40.6668241 23.586758 40.6668241 0 0.212174734"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillOpacity: 0.15,
    fill: "#263238",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    points: "53.8570201 48.3272161 53.4901346 48.1150413 36.5205762 77.7974026 37.0289115 77.7974026 53.870281 48.340477"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.072491)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.688548, 14.144982)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCD40",
    points: "2.21015348 0 17.5265171 26.5218418 0.340363636 56.5799292 41.1088548 56.5799292 41.1088548 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-15)",
    points: "2.21015348 0 17.5265171 26.5218418 0.340363636 56.5799292 41.1088548 56.5799292 41.1088548 0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-17)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.688548, 21.217473)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCD40",
    points: "2.21015348 0 17.5265171 26.5218418 0.340363636 56.5799292 41.1088548 56.5799292 41.1088548 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-15)",
    points: "2.21015348 0 17.5265171 26.5218418 0.340363636 56.5799292 41.1088548 56.5799292 41.1088548 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.688548, 21.217473)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.942149, -21.217473)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB4437",
    points: "0.428769776 0 0.428769776 47.7393152 17.8403589 47.7393152 33.1523022 21.2174734 72.0510035 21.2174734 72.0510035 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-3)",
    points: "0.428769776 0 0.428769776 47.7393152 17.8403589 47.7393152 33.1523022 21.2174734 72.0510035 21.2174734 72.0510035 0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#radialGradient-24)",
    fillRule: "nonzero",
    mask: "url(#mask-23)",
    points: "38.8987013 21.2174734 38.8987013 30.4780165 73.5539079 21.2174734"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.746399, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.746399, 7.072491)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0F9D58",
    points: "0 70.7249115 37.0289115 70.7249115 54.2150649 53.538758 54.2150649 40.6668241 23.586758 40.6668241 0 0.212174734"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-8)",
    points: "0 70.7249115 37.0289115 70.7249115 54.2150649 53.538758 54.2150649 40.6668241 23.586758 40.6668241 0 0.212174734"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#radialGradient-31)",
    fillRule: "nonzero",
    mask: "url(#mask-30)",
    points: "6.17516883 17.8801417 31.4814262 43.1819787 23.586758 47.7393152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#radialGradient-34)",
    fillRule: "nonzero",
    mask: "url(#mask-33)",
    points: "37.0554333 77.7487792 46.3203967 43.1819787 54.2150649 47.7393152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-36)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.217473, 21.217473)",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F1",
    cx: 17.6812279,
    cy: 17.6812279,
    r: 17.6812279
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4285F4",
    cx: 17.6812279,
    cy: 17.6812279,
    r: 14.1449823
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-38)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.072491)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8987013,13.7029516 C29.1342432,13.7029516 21.2174734,21.6197214 21.2174734,31.3841795 L21.2174734,31.8262102 C21.2174734,22.0617521 29.1342432,14.1449823 38.8987013,14.1449823 L77.7974026,14.1449823 L77.7974026,13.7029516 L38.8987013,13.7029516 Z",
    fillOpacity: 0.2,
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1929634,40.6668241 C51.134111,45.9446706 45.4363353,49.507438 38.8987013,49.507438 C32.356647,49.507438 26.6588713,45.9446706 23.6000189,40.6668241 L23.5823377,40.6668241 L0,0.212174734 L0,0.654205431 L23.586758,41.1088548 L23.6044392,41.1088548 C26.6632916,46.3867013 32.3610673,49.9494687 38.9031216,49.9494687 C45.4407556,49.9494687 51.1385313,46.3911216 54.1973837,41.1088548 L54.2194852,41.1088548 L54.2194852,40.6668241 L54.1929634,40.6668241 Z",
    fillOpacity: 0.1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.340732,14.1449823 C39.2655868,14.1449823 39.1948619,14.1538229 39.1197166,14.1582432 C48.7825077,14.2775915 56.5799292,22.1368973 56.5799292,31.8262102 C56.5799292,41.515523 48.7825077,49.3748288 39.1197166,49.4941771 C39.1948619,49.4941771 39.2655868,49.507438 39.340732,49.507438 C49.1051901,49.507438 57.0219599,41.5906682 57.0219599,31.8262102 C57.0219599,22.0617521 49.1051901,14.1449823 39.340732,14.1449823 Z",
    fill: "#3E2723",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3697757,41.2547249 C55.87268,38.6555844 56.7434805,35.6497757 56.7434805,32.4317922 C56.7434805,30.5664227 56.4517403,28.771778 55.9168831,27.0876411 C56.3368123,28.5993861 56.5799292,30.1862763 56.5799292,31.8306305 C56.5799292,35.0486139 55.7091287,38.0544227 54.2062243,40.6535632 L54.2150649,40.6712444 L37.0289115,70.7293318 L37.5416671,70.7293318 L54.3786163,41.2724061 L54.3697757,41.2547249 Z",
    fillOpacity: 0.2,
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-40)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8987013,0.442030697 C60.3062479,0.442030697 77.673634,17.7386919 77.7929823,39.1197166 C77.7929823,39.0445714 77.7974026,38.9738465 77.7974026,38.8987013 C77.7974026,17.4160094 60.3813932,0 38.8987013,0 C17.4160094,0 0,17.4160094 0,38.8987013 C0,38.9738465 0.00442030697,39.0445714 0.00442030697,39.1197166 C0.123768595,17.7386919 17.4911547,0.442030697 38.8987013,0.442030697 Z",
    id: "Path",
    fillOpacity: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8987013,77.3553719 C60.3062479,77.3553719 77.673634,60.0587107 77.7929823,38.677686 C77.7929823,38.7528312 77.7974026,38.8235561 77.7974026,38.8987013 C77.7974026,60.3813932 60.3813932,77.7974026 38.8987013,77.7974026 C17.4160094,77.7974026 0,60.3813932 0,38.8987013 C0,38.8235561 0.00442030697,38.7528312 0.00442030697,38.677686 C0.123768595,60.0587107 17.4911547,77.3553719 38.8987013,77.3553719 Z",
    id: "Path",
    fillOpacity: 0.15,
    fill: "#3E2723"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#radialGradient-41)",
    fillRule: "nonzero",
    cx: 38.8987013,
    cy: 38.8987013,
    r: 38.8987013
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeBrowser);
export default __webpack_public_path__ + "static/media/chrome-browser.2d3d1cba2bc57c7bac0890da0ccc21f6.svg";
export { ForwardRef as ReactComponent };